import React, {useMemo, memo} from 'react';
import {renderMoment} from 'lib/timeUtils';
import type {AssignmentModelV3} from '@albert-io/models';

import PastDueBadge from './PastDueBadge/PastDueBadge.react';

interface DueDateContentProps {
  assignment: AssignmentModelV3;
  classroomId: string;
  studentId?: string;
}

const DueDateContent = ({assignment, classroomId, studentId}: DueDateContentProps) => {
  const pastDueBadge = useMemo(() => {
    if (
      assignment.isComplete() === false &&
      assignment.isPastDue({
        classroomId,
        studentId
      }) &&
      assignment.getIsAllowLateSubmissionsFromSettings({
        classroomId,
        studentId
      })
    ) {
      return <PastDueBadge />;
    }
    return null;
  }, [assignment, classroomId, studentId]);

  return (
    <span>
      {`${renderMoment(
        assignment.getDueDateFromSettings({
          classroomId,
          studentId
        }),
        'dateFormal'
      )}, `}
      {renderMoment(
        assignment.getDueDateFromSettings({
          classroomId,
          studentId
        }),
        'time'
      )}
      <br />
      {pastDueBadge}
    </span>
  );
};

export default memo(DueDateContent);
